import { Checkbox, Dropdown, Input, Menu, Modal, Select } from 'antd';
import PageHeader from 'design-components/PageHeader';
import paths from 'pages/Router/paths';
import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { setBreadcrumb } from 'state/actions/breadcrumb';
import {
  createRole,
  deleteRole,
  fetchRoles,
  modifyRole,
} from 'state/actions/roles';
import { fetchUsers } from 'state/actions/users';
import _ from 'underscore';
import RolesTable from './RolesTable';
import './Users.scss';
import { log } from 'utils';

function Role() {
  const [search, setSearch] = useState('');
  const [selectedOrganization, setSelectedOrganization] = useState('All');
  const [data, setData] = useState([]);
  const [isModalShow, setIsModalShow] = useState(false);
  const [form, setForm] = useState({
    id: '',
    name: '',
    access: [],
  });

  const {
    roleList,
    loading,
    sites,
    organizations,
    success,
    created,
  } = useSelector(
    (state) => ({
      roleList: state.roles.list,
      userList: state.users.list,
      // isAdmin: state.auth.userData.isAdmin,
      error: state.roles.error,
      loading: state.roles.loading,
      deleted: state.roles.deleted,
      userData: state.auth.userData,
      sites: state.sites.list,
      organizations: state.organizations.list,
      success: state.roles.success,
      created: state.roles.created,
    }),
    shallowEqual
  );

  const dispatch = useDispatch();
  const [role, setRole] = useState(null);

  useEffect(() => {
    fetchData();
  }, [dispatch]);

 const fetchData = async () => {
    try {
      const roleData = await getRole();
      setRole(roleData);
    } catch (error) {
      log('Error retrieving role:', error);
    }
  };


  useEffect(() => {
    if (role === 'admin' || role === 'superadmin') {
      dispatch(fetchUsers());
    }
  }, [dispatch, role]);

  useEffect(() => {
    if (success && !loading) {
      setIsModalShow(false);
      setForm({
        id: '',
        name: '',
        access: [],
      });
    }
  }, [success, loading]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    dispatch(fetchRoles());
    dispatch(
      setBreadcrumb([
        { menu: 'Access Management', link: `/roles` },
        { menu: 'Roles', link: `/roles` },
      ])
    );
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (created) {
      dispatch(fetchRoles());
    }
  }, [created]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (sites) {
      setData([
        ...data,
        ..._.sortBy(sites, 'name').map((site) => {
          return {
            id: site._id,
            title:
              site.name.length > 20
                ? `${site.name.substr(0, 20)}...`
                : site.name,
            key: site._id,
            site_id: site._id,
            organization_id: site.organizationId,
            children: [
              {
                key: `poi-${site._id}`,
                organization_id: site.organizationId,
                id: `poi-${site._id}`,
                parent_id: site._id,
                site_id: site._id,
                title: 'POI',
                module: 'poi',
                children: [
                  {
                    key: `read-poi-${site._id}`,
                    organization_id: site.organizationId,
                    id: `read-poi-${site._id}`,
                    parent_id: `poi-${site._id}`,
                    site_id: site._id,
                    title: 'Read POI',
                    type: 'read',
                    module: 'poi',
                  },
                  {
                    key: `create-poi-${site._id}`,
                    organization_id: site.organizationId,
                    id: `create-poi-${site._id}`,
                    parent_id: `poi-${site._id}`,
                    site_id: site._id,
                    title: 'Create POI',
                    type: 'create',
                    module: 'poi',
                  },
                  {
                    key: `update-poi-${site._id}`,
                    organization_id: site.organizationId,
                    id: `update-poi-${site._id}`,
                    parent_id: `poi-${site._id}`,
                    site_id: site._id,
                    title: 'Update POI',
                    type: 'update',
                    module: 'poi',
                  },
                  {
                    key: `delete-poi-${site._id}`,
                    organization_id: site.organizationId,
                    id: `delete-poi-${site._id}`,
                    parent_id: `poi-${site._id}`,
                    site_id: site._id,
                    title: 'Delete POI',
                    type: 'delete',
                    module: 'poi',
                  },
                ],
              },
              {
                key: `media-${site._id}`,
                organization_id: site.organizationId,
                id: `media-${site._id}`,
                parent_id: site._id,
                site_id: site._id,
                title: 'Media',
                module: 'media',
                children: [
                  {
                    key: `read-media-${site._id}`,
                    organization_id: site.organizationId,
                    id: `read-media-${site._id}`,
                    parent_id: `media-${site._id}`,
                    site_id: site._id,
                    title: 'Read Media',
                    type: 'read',
                    module: 'media',
                  },
                  {
                    key: `create-media-${site._id}`,
                    organization_id: site.organizationId,
                    id: `create-media-${site._id}`,
                    parent_id: `media-${site._id}`,
                    site_id: site._id,
                    title: 'Create Media',
                    type: 'create',
                    module: 'media',
                  },
                  {
                    key: `update-media-${site._id}`,
                    organization_id: site.organizationId,
                    id: `update-media-${site._id}`,
                    parent_id: `media-${site._id}`,
                    site_id: site._id,
                    title: 'Update Media',
                    type: 'update',
                    module: 'media',
                  },
                  {
                    key: `delete-media-${site._id}`,
                    organization_id: site.organizationId,
                    id: `delete-media-${site._id}`,
                    parent_id: `media-${site._id}`,
                    site_id: site._id,
                    title: 'Delete Media',
                    type: 'delete',
                    module: 'media',
                  },
                ],
              },
              {
                key: `information-${site._id}`,
                organization_id: site.organizationId,
                id: `information-${site._id}`,
                parent_id: site._id,
                site_id: site._id,
                title: 'Information',
                module: 'information',
                children: [
                  {
                    key: `read-information-${site._id}`,
                    organization_id: site.organizationId,
                    id: `read-information-${site._id}`,
                    parent_id: `information-${site._id}`,
                    site_id: site._id,
                    title: 'Read Information',
                    type: 'read',
                    module: 'information',
                  },
                  {
                    key: `create-information-${site._id}`,
                    organization_id: site.organizationId,
                    id: `create-information-${site._id}`,
                    parent_id: `information-${site._id}`,
                    site_id: site._id,
                    title: 'Create Information',
                    type: 'create',
                    module: 'information',
                  },
                  {
                    key: `update-information-${site._id}`,
                    organization_id: site.organizationId,
                    id: `update-information-${site._id}`,
                    parent_id: `information-${site._id}`,
                    site_id: site._id,
                    title: 'Update Information',
                    type: 'update',
                    module: 'information',
                  },
                  {
                    key: `delete-information-${site._id}`,
                    organization_id: site.organizationId,
                    id: `delete-information-${site._id}`,
                    parent_id: `information-${site._id}`,
                    site_id: site._id,
                    title: 'Delete Information',
                    type: 'delete',
                    module: 'information',
                  },
                ],
              },
              {
                key: `programme-${site._id}`,
                organization_id: site.organizationId,
                id: `programme-${site._id}`,
                parent_id: site._id,
                site_id: site._id,
                title: 'Programme',
                module: 'programme',
                children: [
                  {
                    key: `read-programme-${site._id}`,
                    organization_id: site.organizationId,
                    id: `read-programme-${site._id}`,
                    parent_id: `programme-${site._id}`,
                    site_id: site._id,
                    title: 'Read Programme',
                    type: 'read',
                    module: 'programme',
                  },
                  {
                    key: `create-programme-${site._id}`,
                    organization_id: site.organizationId,
                    id: `create-programme-${site._id}`,
                    parent_id: `programme-${site._id}`,
                    site_id: site._id,
                    title: 'Create Programme',
                    type: 'create',
                    module: 'programme',
                  },
                  {
                    key: `update-programme-${site._id}`,
                    organization_id: site.organizationId,
                    id: `update-programme-${site._id}`,
                    parent_id: `programme-${site._id}`,
                    site_id: site._id,
                    title: 'Update Programme',
                    type: 'update',
                    module: 'programme',
                  },
                  {
                    key: `delete-programme-${site._id}`,
                    organization_id: site.organizationId,
                    id: `delete-programme-${site._id}`,
                    parent_id: `programme-${site._id}`,
                    site_id: site._id,
                    title: 'Delete Programme',
                    type: 'delete',
                    module: 'programme',
                  },
                ],
              },
              {
                key: `approval-${site._id}`,
                organization_id: site.organizationId,
                id: `approval-${site._id}`,
                parent_id: site._id,
                site_id: site._id,
                title: 'Approval',
                module: 'approval',
                children: [
                  {
                    key: `approval-${site._id}`,
                    organization_id: site.organizationId,
                    id: `approval-${site._id}`,
                    parent_id: `approval-${site._id}`,
                    site_id: site._id,
                    title: 'Approval Update',
                    type: 'update',
                    module: 'approval',
                  },
                ],
              },
              {
                key: `dynamiccomponent-${site._id}`,
                organization_id: site.organizationId,
                id: `dynamiccomponent-${site._id}`,
                parent_id: site._id,
                site_id: site._id,
                title: 'Dynamic Components',
                module: 'dynamiccomponent',
                children: [
                  {
                    key: `read-dynamiccomponent-${site._id}`,
                    organization_id: site.organizationId,
                    id: `read-dynamiccomponent-${site._id}`,
                    parent_id: `dynamiccomponent-${site._id}`,
                    site_id: site._id,
                    title: 'Read Dynamic Components',
                    type: 'read',
                    module: 'dynamiccomponent',
                  },
                  {
                    key: `create-dynamiccomponent-${site._id}`,
                    organization_id: site.organizationId,
                    id: `create-dynamiccomponent-${site._id}`,
                    parent_id: `dynamiccomponent-${site._id}`,
                    site_id: site._id,
                    title: 'Create Dynamic Components',
                    type: 'create',
                    module: 'dynamiccomponent',
                  },
                  {
                    key: `update-dynamiccomponent-${site._id}`,
                    organization_id: site.organizationId,
                    id: `update-dynamiccomponent-${site._id}`,
                    parent_id: `dynamiccomponent-${site._id}`,
                    site_id: site._id,
                    title: 'Update Dynamic Components',
                    type: 'update',
                    module: 'dynamiccomponent',
                  },
                  {
                    key: `delete-dynamiccomponent-${site._id}`,
                    organization_id: site.organizationId,
                    id: `delete-dynamiccomponent-${site._id}`,
                    parent_id: `dynamiccomponent-${site._id}`,
                    site_id: site._id,
                    title: 'Delete Dynamic Components',
                    type: 'delete',
                    module: 'dynamiccomponent',
                  },
                ],
              },
              {
                key: `websiteBuilder-${site._id}`,
                organization_id: site.organizationId,
                id: `websiteBuilder-${site._id}`,
                parent_id: site._id,
                site_id: site._id,
                title: 'Website Builder',
                group: 'websiteBuilder',
                children: [
                  {
                    key: `post-${site._id}`,
                    organization_id: site.organizationId,
                    id: `post-${site._id}`,
                    parent_id: `websiteBuilder-${site._id}`,
                    site_id: site._id,
                    title: 'Post',
                    module: 'post',
                    children: [
                      {
                        key: `read-post-${site._id}`,
                        organization_id: site.organizationId,
                        id: `read-post-${site._id}`,
                        parent_id: `post-${site._id}`,
                        site_id: site._id,
                        title: 'Read Post',
                        type: 'read',
                        module: 'post',
                      },
                      {
                        key: `create-post-${site._id}`,
                        organization_id: site.organizationId,
                        id: `create-post-${site._id}`,
                        parent_id: `post-${site._id}`,
                        site_id: site._id,
                        title: 'Create Post',
                        type: 'create',
                        module: 'post',
                      },
                      {
                        key: `update-post-${site._id}`,
                        organization_id: site.organizationId,
                        id: `update-post-${site._id}`,
                        parent_id: `post-${site._id}`,
                        site_id: site._id,
                        title: 'Update Post',
                        type: 'update',
                        module: 'post',
                      },
                      {
                        key: `delete-post-${site._id}`,
                        organization_id: site.organizationId,
                        id: `delete-post-${site._id}`,
                        parent_id: `post-${site._id}`,
                        site_id: site._id,
                        title: 'Delete Post',
                        type: 'delete',
                        module: 'post',
                      },
                    ],
                  },
                  {
                    key: `pages-${site._id}`,
                    organization_id: site.organizationId,
                    id: `pages-${site._id}`,
                    parent_id: `websiteBuilder-${site._id}`,
                    site_id: site._id,
                    title: 'Pages',
                    module: 'pages',
                    children: [
                      {
                        key: `read-pages-${site._id}`,
                        organization_id: site.organizationId,
                        id: `read-pages-${site._id}`,
                        parent_id: `pages-${site._id}`,
                        site_id: site._id,
                        title: 'Read Pages',
                        type: 'read',
                        module: 'pages',
                      },
                      {
                        key: `create-pages-${site._id}`,
                        organization_id: site.organizationId,
                        id: `create-pages-${site._id}`,
                        parent_id: `pages-${site._id}`,
                        site_id: site._id,
                        title: 'Create Pages',
                        type: 'create',
                        module: 'pages',
                      },
                      {
                        key: `update-pages-${site._id}`,
                        organization_id: site.organizationId,
                        id: `update-pages-${site._id}`,
                        parent_id: `pages-${site._id}`,
                        site_id: site._id,
                        title: 'Update Pages',
                        type: 'update',
                        module: 'pages',
                      },
                      {
                        key: `delete-pages-${site._id}`,
                        organization_id: site.organizationId,
                        id: `delete-pages-${site._id}`,
                        parent_id: `pages-${site._id}`,
                        site_id: site._id,
                        title: 'Delete Pages',
                        type: 'delete',
                        module: 'pages',
                      },
                    ],
                  },
                  {
                    key: `layoutConfig-${site._id}`,
                    organization_id: site.organizationId,
                    id: `layoutConfig-${site._id}`,
                    parent_id: `websiteBuilder-${site._id}`,
                    site_id: site._id,
                    title: 'Layout Config',
                    module: 'layoutConfig',
                    children: [
                      {
                        key: `read-layoutConfig-${site._id}`,
                        organization_id: site.organizationId,
                        id: `read-layoutConfig-${site._id}`,
                        parent_id: `layoutConfig-${site._id}`,
                        site_id: site._id,
                        title: 'Read Layout Config',
                        type: 'read',
                        module: 'layoutConfig',
                      },
                      {
                        key: `create-layoutConfig-${site._id}`,
                        organization_id: site.organizationId,
                        id: `create-layoutConfig-${site._id}`,
                        parent_id: `layoutConfig-${site._id}`,
                        site_id: site._id,
                        title: 'Create Layout Config',
                        type: 'create',
                        module: 'layoutConfig',
                      },
                      {
                        key: `update-layoutConfig-${site._id}`,
                        organization_id: site.organizationId,
                        id: `update-layoutConfig-${site._id}`,
                        parent_id: `layoutConfig-${site._id}`,
                        site_id: site._id,
                        title: 'Update Layout Config',
                        type: 'update',
                        module: 'layoutConfig',
                      },
                      {
                        key: `delete-layoutConfig-${site._id}`,
                        organization_id: site.organizationId,
                        id: `delete-layoutConfig-${site._id}`,
                        parent_id: `layoutConfig-${site._id}`,
                        site_id: site._id,
                        title: 'Delete Layout Config',
                        type: 'delete',
                        module: 'layoutConfig',
                      },
                    ],
                  },
                  {
                    key: `menu-${site._id}`,
                    organization_id: site.organizationId,
                    id: `menu-${site._id}`,
                    parent_id: `websiteBuilder-${site._id}`,
                    site_id: site._id,
                    title: 'Menu',
                    module: 'menu',
                    children: [
                      {
                        key: `read-menu-${site._id}`,
                        organization_id: site.organizationId,
                        id: `read-menu-${site._id}`,
                        parent_id: `menu-${site._id}`,
                        site_id: site._id,
                        title: 'Read Menu',
                        type: 'read',
                        module: 'menu',
                      },
                      {
                        key: `create-menu-${site._id}`,
                        organization_id: site.organizationId,
                        id: `create-menu-${site._id}`,
                        parent_id: `menu-${site._id}`,
                        site_id: site._id,
                        title: 'Create Menu',
                        type: 'create',
                        module: 'menu',
                      },
                      {
                        key: `update-menu-${site._id}`,
                        organization_id: site.organizationId,
                        id: `update-menu-${site._id}`,
                        parent_id: `menu-${site._id}`,
                        site_id: site._id,
                        title: 'Update Menu',
                        type: 'update',
                        module: 'menu',
                      },
                      {
                        key: `delete-menu-${site._id}`,
                        organization_id: site.organizationId,
                        id: `delete-menu-${site._id}`,
                        parent_id: `menu-${site._id}`,
                        site_id: site._id,
                        title: 'Delete Menu',
                        type: 'delete',
                        module: 'menu',
                      },
                    ],
                  },
                ],
              },
              // {
              //   key: `feedback-${site._id}`,
              //   organization_id: site.organizationId,
              //   id: `feedback-${site._id}`,
              //   parent_id: site._id,
              //   site_id: site._id,
              //   title: 'Feedback',
              //   module: 'feedback',
              //   children: [
              //     {
              //       key: `read-feedback-${site._id}`,
              //       organization_id: site.organizationId,
              //       id: `read-feedback-${site._id}`,
              //       parent_id: `feedback-${site._id}`,
              //       site_id: site._id,
              //       title: 'Read Feedback',
              //       type: 'read',
              //       module: 'feedback',
              //     },
              //     {
              //       key: `create-feedback-${site._id}`,
              //       organization_id: site.organizationId,
              //       id: `create-feedback-${site._id}`,
              //       parent_id: `feedback-${site._id}`,
              //       site_id: site._id,
              //       title: 'Create Feedback',
              //       type: 'create',
              //       module: 'feedback',
              //     },
              //     {
              //       key: `update-feedback-${site._id}`,
              //       organization_id: site.organizationId,
              //       id: `update-feedback-${site._id}`,
              //       parent_id: `feedback-${site._id}`,
              //       site_id: site._id,
              //       title: 'Update Feedback',
              //       type: 'update',
              //       module: 'feedback',
              //     },
              //     {
              //       key: `delete-feedback-${site._id}`,
              //       organization_id: site.organizationId,
              //       id: `delete-feedback-${site._id}`,
              //       parent_id: `feedback-${site._id}`,
              //       site_id: site._id,
              //       title: 'Delete Feedback',
              //       type: 'delete',
              //       module: 'feedback',
              //     },
              //   ],
              // },
              // {
              //   key: `map-${site._id}`,
              //   organization_id: site.organizationId,
              //   id: `map-${site._id}`,
              //   parent_id: site._id,
              //   site_id: site._id,
              //   title: 'Maps',
              //   module: 'map',
              //   children: [
              //     {
              //       key: `read-map-${site._id}`,
              //       organization_id: site.organizationId,
              //       id: `read-map-${site._id}`,
              //       parent_id: `map-${site._id}`,
              //       site_id: site._id,
              //       title: 'Read Maps',
              //       type: 'read',
              //       module: 'map',
              //     },
              //     {
              //       key: `create-map-${site._id}`,
              //       organization_id: site.organizationId,
              //       id: `create-map-${site._id}`,
              //       parent_id: `map-${site._id}`,
              //       site_id: site._id,
              //       title: 'Create Maps',
              //       type: 'create',
              //       module: 'map',
              //     },
              //     {
              //       key: `update-map-${site._id}`,
              //       organization_id: site.organizationId,
              //       id: `update-map-${site._id}`,
              //       parent_id: `map-${site._id}`,
              //       site_id: site._id,
              //       title: 'Update Maps',
              //       type: 'update',
              //       module: 'map',
              //     },
              //     {
              //       key: `delete-map-${site._id}`,
              //       organization_id: site.organizationId,
              //       id: `delete-map-${site._id}`,
              //       parent_id: `map-${site._id}`,
              //       site_id: site._id,
              //       title: 'Delete Maps',
              //       type: 'delete',
              //       module: 'map',
              //     },
              //   ],
              // },
            ],
          };
        }),
      ]);
    }
  }, [sites]); // eslint-disable-line react-hooks/exhaustive-deps

  const redirect =
    role === 'admin' || role === 'superadmin' ? (
      false
    ) : (
      <Redirect to={paths.ROOT} />
    );

  const columns = [
    {
      title: () => (
        <div className="search-permission">
          <input
            onChange={(e) => handleSearch(e.target.value)}
            placeholder="Start typing site name"
            className="search-permission-input"
          />
          <i className="feather-search icon-search-permission" />
        </div>
      ),
      dataIndex: 'title',
      key: 'title',
      width: 300,
      fixed: 'left',
    },
  ];

  const columnsPermission = roleList
    ? [
        ...columns,
        ...roleList
          .sort((a, b) => {
            if (a.name < b.name) {
              return -1;
            } else {
              return 1;
            }
          })
          .map((role) => {
            return {
              title: () => (
                <div className="permission-title">
                  <div className="permission-title-content">
                    <p className="permission-title-text">Name</p>
                    <p className="permission-subtitle-text">{role.name}</p>
                  </div>
                  <Dropdown
                    overlay={
                      <Menu>
                        <Menu.Item key="0" onClick={() => handleEdit(role._id)}>
                          <i className="feather-edit mr-1/5" />
                          Edit
                        </Menu.Item>
                        <Menu.Item
                          key="1"
                          onClick={() => onRemoveButtonClickHandler(role._id)}
                        >
                          <i className="feather-delete mr-1/5" />
                          Delete
                        </Menu.Item>
                      </Menu>
                    }
                    trigger={['click']}
                  >
                    <button className="permission-menu">
                      <i className="feather-more-vertical" />
                    </button>
                  </Dropdown>
                </div>
              ),
              dataIndex: 'site_id',
              key: 'site_id',
              align: 'center',
              render: (site_id, record) => {
                const findAccess =
                  role.access &&
                  role.access.find((access) => access.siteId === site_id);

                if (record.module) {
                  if (record.type) {
                    const allow =
                      findAccess &&
                      findAccess[record.module] &&
                      findAccess[record.module][record.type]
                        ? findAccess[record.module][record.type]
                        : false;
                    return (
                      <Checkbox
                        onChange={(e) =>
                          handleAllow(
                            role._id,
                            site_id,
                            record.module,
                            record.type,
                            e.target.checked
                          )
                        }
                        checked={allow}
                      />
                    );
                  } else {
                    const countChildren = record.children;
                    const totalChildren = findAccess
                      ? _.flatten(
                          countChildren.map(
                            (x) =>
                              findAccess[x.module] &&
                              findAccess[x.module][x.type]
                          )
                        )
                      : [];

                    const howManyTrueChildren = totalChildren.filter((x) => x);

                    return (
                      <Checkbox
                        onChange={(e) =>
                          handleAllowSome(
                            role._id,
                            site_id,
                            record.module,
                            e.target.checked
                          )
                        }
                        indeterminate={
                          howManyTrueChildren.length !== totalChildren.length &&
                          howManyTrueChildren.length > 0
                        }
                        checked={
                          howManyTrueChildren.length === totalChildren.length &&
                          findAccess
                        }
                      />
                    );
                  }
                } else if (record.group) {
                  const leaves = findAccess
                    ? _.flatten(
                        record.children.map((m) =>
                          m.children.map(
                            (t) =>
                              findAccess[t.module] &&
                              findAccess[t.module][t.type]
                          )
                        )
                      )
                    : [];
                  const trueLeaves = leaves.filter((x) => x);

                  return (
                    <Checkbox
                      onChange={(e) =>
                        handleAllowGroup(
                          role._id,
                          site_id,
                          record.children.map((m) => m.module),
                          e.target.checked
                        )
                      }
                      indeterminate={
                        trueLeaves.length !== leaves.length &&
                        trueLeaves.length > 0
                      }
                      checked={trueLeaves.length === leaves.length && findAccess}
                    />
                  );
                } else {
                  const countChildren = record.children;
                  // Group rows (Website Builder) hold modules one level deeper.
                  const totalChildren = findAccess
                    ? _.flatten(
                        countChildren.map((x) =>
                          x.module
                            ? x.children.map(
                                (t) =>
                                  findAccess[t.module] &&
                                  findAccess[t.module][t.type]
                              )
                            : x.children.map((m) =>
                                m.children.map(
                                  (t) =>
                                    findAccess[t.module] &&
                                    findAccess[t.module][t.type]
                                )
                              )
                        )
                      )
                    : [];

                  const howManyTrueChildren = totalChildren.filter((x) => x);

                  return (
                    <Checkbox
                      onChange={(e) =>
                        handleAllowAll(role._id, site_id, e.target.checked)
                      }
                      indeterminate={
                        howManyTrueChildren.length !== totalChildren.length &&
                        howManyTrueChildren.length > 0
                      }
                      checked={
                        howManyTrueChildren.length === totalChildren.length &&
                        findAccess
                      }
                    />
                  );
                }
              },
            };
          }),
      ]
    : columns;

  const handleSearch = (value) => {
    setSearch(value);
  };

  const handleChangeOrg = (value) => {
    setSelectedOrganization(value);
  };

  const handleAllow = (id, siteId, module, type, checked) => {
    const findRoleList = [...roleList].find((x) => x._id === id);
    const findAccess = [...findRoleList.access].find(
      (x) => x.siteId === siteId
    );
    if (findAccess) {
      if (!findAccess[module]) {
        findAccess[module] = {
          create: false,
          read: false,
          update: false,
          delete: false,
        }
      }
        findAccess[module][type] = checked;
        dispatch(modifyRole({ ...findRoleList, id: id }));
    } else {
      const allows = {
        poi: {
          create: false,
          read: false,
          update: false,
          delete: false,
        },
        media: {
          create: false,
          read: false,
          update: false,
          delete: false,
        },
        information: {
          create: false,
          read: false,
          update: false,
          delete: false,
        },
        programme: {
          create: false,
          read: false,
          update: false,
          delete: false,
        },
        approval: {
          update: false,
        },
        dynamiccomponent: {
          create: false,
          read: false,
          update: false,
          delete: false,
        },
        post: {
          create: false,
          read: false,
          update: false,
          delete: false,
        },
        pages: {
          create: false,
          read: false,
          update: false,
          delete: false,
        },
        layoutConfig: {
          create: false,
          read: false,
          update: false,
          delete: false,
        },
        menu: {
          create: false,
          read: false,
          update: false,
          delete: false,
        },
      };

      allows[module][type] = checked;
      allows.siteId = siteId;

      const newAccess = {
        ...findRoleList,
        access: findRoleList.access
          ? [...findRoleList.access, allows]
          : [allows],
      };
      dispatch(modifyRole({ ...newAccess, id: newAccess._id }));
    }
  };

  const handleAllowSome = (id, siteId, module, checked) => {
    const findRoleList = [...roleList].find((x) => x._id === id);
    const findAccess = [...findRoleList.access].find(
      (x) => x.siteId === siteId
    );

    if (findAccess) {
      if (findAccess[module]) {
        if (findAccess[module].create !== undefined) {
          findAccess[module].create = checked;
        }
        if (findAccess[module].delete !== undefined) {
          findAccess[module].delete = checked;
        }
        if (findAccess[module].read !== undefined) {
          findAccess[module].read = checked;
        }
        if (findAccess[module].update !== undefined) {
          findAccess[module].update = checked;
        }
      } else {
        findAccess[module] = {
          create: true,
          delete: true,
          read: true,
          update: true,
        };
      }
      dispatch(modifyRole({ ...findRoleList, id: id }));
    } else {
      const allows = {
        // api: {
        //   create: false,
        //   read: false,
        //   update: false,
        //   delete: false,
        // },
        poi: {
          create: false,
          read: false,
          update: false,
          delete: false,
        },
        media: {
          create: false,
          read: false,
          update: false,
          delete: false,
        },
        information: {
          create: false,
          read: false,
          update: false,
          delete: false,
        },
        programme: {
          create: false,
          read: false,
          update: false,
          delete: false,
        },

        approval: {
          update: false,
        },
        dynamiccomponent: {
          create: false,
          read: false,
          update: false,
          delete: false,
        },
        post: {
          create: false,
          read: false,
          update: false,
          delete: false,
        },
        pages: {
          create: false,
          read: false,
          update: false,
          delete: false,
        },
        layoutConfig: {
          create: false,
          read: false,
          update: false,
          delete: false,
        },
        menu: {
          create: false,
          read: false,
          update: false,
          delete: false,
        },
        // feedback: {
        //   create: false,
        //   read: false,
        //   update: false,
        //   delete: false,
        // },
        // map: {
        //   create: false,
        //   read: false,
        //   update: false,
        //   delete: false,
        // },
      };

      allows[module].create = checked;
      allows[module].delete = checked;
      allows[module].read = checked;
      allows[module].update = checked;
      allows.siteId = siteId;

      const newAccess = {
        ...findRoleList,
        access: findRoleList.access
          ? [...findRoleList.access, allows]
          : [allows],
      };
      console.log(newAccess, 'new access some');
      dispatch(modifyRole({ ...newAccess, id: newAccess._id }));
    }
  };

  const handleAllowGroup = (id, siteId, modules, checked) => {
    const findRoleList = [...roleList].find((x) => x._id === id);
    const findAccess = [...findRoleList.access].find(
      (x) => x.siteId === siteId
    );

    if (findAccess) {
      modules.forEach((module) => {
        findAccess[module] = {
          create: checked,
          read: checked,
          update: checked,
          delete: checked,
        };
      });
      dispatch(modifyRole({ ...findRoleList, id }));
    } else {
      const allows = { siteId };
      modules.forEach((module) => {
        allows[module] = {
          create: checked,
          read: checked,
          update: checked,
          delete: checked,
        };
      });

      const newAccess = {
        ...findRoleList,
        access: findRoleList.access
          ? [...findRoleList.access, allows]
          : [allows],
      };
      dispatch(modifyRole({ ...newAccess, id: newAccess._id }));
    }
  };

  const handleAllowAll = (id, siteId, checked) => {
    const findRoleList = [...roleList].find((x) => x._id === id);
    const findAccess = [...findRoleList.access].find(
      (x) => x.siteId === siteId
    );

    if (findAccess) {
      const accessMap = Object.keys(findAccess);
      if (!accessMap.find((acc) => acc === 'approval')) {
        findAccess.approval = { update: checked };
      }
      // Roles saved before these modules existed don't have them yet.
      ['dynamiccomponent', 'post', 'pages', 'layoutConfig', 'menu'].forEach(
        (module) => {
          if (!findAccess[module]) {
            findAccess[module] = {
              create: checked,
              read: checked,
              update: checked,
              delete: checked,
            };
          }
        }
      );
      accessMap.map((x) => {
        if (x !== 'siteId') {
          findAccess[x].create = checked;
          findAccess[x].delete = checked;
          findAccess[x].read = checked;
          findAccess[x].update = checked;
        }
        return null;
      });
      console.log(findAccess, 'find access');

      dispatch(modifyRole({ ...findRoleList, id: findRoleList._id }));
    } else {
      const allows = {
        // api: {
        //   create: checked,
        //   read: checked,
        //   update: checked,
        //   delete: checked,
        // },
        poi: {
          create: checked,
          read: checked,
          update: checked,
          delete: checked,
        },
        media: {
          create: checked,
          read: checked,
          update: checked,
          delete: checked,
        },
        information: {
          create: checked,
          read: checked,
          update: checked,
          delete: checked,
        },
        programme: {
          create: checked,
          read: checked,
          update: checked,
          delete: checked,
        },

        approval: {
          update: checked,
        },
        dynamiccomponent: {
          create: checked,
          read: checked,
          update: checked,
          delete: checked,
        },
        post: {
          create: checked,
          read: checked,
          update: checked,
          delete: checked,
        },
        pages: {
          create: checked,
          read: checked,
          update: checked,
          delete: checked,
        },
        layoutConfig: {
          create: checked,
          read: checked,
          update: checked,
          delete: checked,
        },
        menu: {
          create: checked,
          read: checked,
          update: checked,
          delete: checked,
        },
        // feedback: {
        //   create: checked,
        //   read: checked,
        //   update: checked,
        //   delete: checked,
        // },
        // map: {
        //   create: checked,
        //   read: checked,
        //   update: checked,
        //   delete: checked,
        // },
        siteId,
      };

      const newAccess = {
        ...findRoleList,
        access: findRoleList.access
          ? [...findRoleList.access, allows]
          : [allows],
      };
      console.log(newAccess, 'new access');
      dispatch(modifyRole({ ...newAccess, id: newAccess._id }));
    }
  };

  const handleChangeInput = (name, value) => {
    setForm({
      ...form,
      [name]: value,
    });
  };

  const handleSubmit = () => {
    if (form.id) {
      dispatch(modifyRole({ ...form, id: form._id }));
    } else {
      dispatch(createRole(form));
    }
  };

  const handleEdit = (id) => {
    const findRole = roleList.find((x) => x._id === id);
    setForm({
      ...form,
      ...findRole,
      id,
    });
    setIsModalShow(true);
  };

  const handleCloseModal = () => {
    setForm({
      id: '',
      name: '',
      access: [],
    });
    setIsModalShow(false);
  };

  const onRemoveButtonClickHandler = (roleId) => {
    Modal.confirm({
      title: 'Are you sure want to delete this role?',
      content: 'Data cannot be restored after delete',
      onOk: () => dispatch(deleteRole(roleId)),
      okButtonProps: {
        loading,
      },
    });
  };

  return (
    <section className="roles">
      {role && redirect}
      <Modal
        title={form.id ? 'Edit Role' : 'Add new Role'}
        visible={isModalShow}
        onCancel={handleCloseModal}
        okButtonProps={{
          loading,
        }}
        okText={form.id ? 'Save Changes' : 'Save'}
        onOk={handleSubmit}
      >
        <label style={{ marginBottom: '0.5em' }}>
          Role Name <span className="is-required">*</span>
        </label>
        <Input
          onChange={(e) => handleChangeInput('name', e.target.value)}
          required
          placeholder="eg: Administrator"
          value={form.name}
        />
      </Modal>
      <PageHeader
        title="Roles"
        isGrid={false}
        isSearch={false}
        isAdd={false}
        addLabel=""
      />
      <div className="roles__table">
        <div className="header-content">
          <div className="left-content">
            <label>Select Organization</label>
            <Select defaultValue="All" onChange={handleChangeOrg}>
              <Select.Option value="All">All Organization</Select.Option>
              {organizations &&
                organizations.map((organization) => {
                  return (
                    <Select.Option
                      value={organization._id}
                      key={organization._id}
                    >
                      {organization.name}
                    </Select.Option>
                  );
                })}
            </Select>
          </div>
          <button
            className="button-primary"
            onClick={() => setIsModalShow(true)}
          >
            <i className="feather-plus" />
            Add Roles
          </button>
        </div>
        <div className="table">
          <RolesTable
            data={data}
            columns={columnsPermission}
            search={search}
            selectedOrganization={selectedOrganization}
            loading={loading}
          />
        </div>
      </div>
    </section>
  );
}

export default Role;
